import httpService from '../../http'
import api from '../../api'
import helpers from '../../helpers'
const apiModule = api.admins
const errorsStr = helpers.error.errors
const mapper = helpers.mapper

function role () { return localStorage.getItem('role') }

const state = {
  tabs: {
    admin: {
      proceeds: {
        data: 'proceeds',
        title: 'Прибыль',
        active: true
      },
      massage: {
        data: 'massage',
        title: 'Массаж',
        active: false
      },
      rating: {
        data: 'rating',
        title: 'Рейтинг',
        active: false
      },
      questions: {
        data: 'questions',
        title: 'Опрос',
        active: false
      }
    },
    dealer: {
      proceeds: {
        data: 'proceeds',
        title: 'Прибыль',
        active: true
      },
      massage: {
        data: 'massage',
        title: 'Массаж',
        active: false
      },
      rating: {
        data: 'rating',
        title: 'Рейтинг',
        active: false
      }
    }
  },
  proceeds: {
    orderEnd: [],
    orderReturn: [],
    labels: [],
    total: { end: 0, return: 0 }
  },
  proceedsReport: null,
  massage: {
    massages: [],
    labels: [],
    total: { massage: 0 }
  },
  urlProceeds: '',
  urlMassage: '',

  questions: [],
  questionId: null,
  questionsStat: {
    data: [],
    labels: []
  },
  urlQuestions: '',

  ordersRating: {
    rating: null,
    labels: [],
    data: []
  },
  ordersKontrollersDistinct: [],
  findKontroller: '',
  urlRatingReport: ''
}
const getters = {
  getTabs (state) { return state.tabs[role()] },
  getProceeds (state) { return state.proceeds },
  getProceedsReport (state) { return state.proceedsReport },
  getMassage (state) { return state.massage },
  getUrlProceeds (state) { return state.urlProceeds },
  getUrlMassage (state) { return state.urlMassage },
  getQuestions (state) { return state.questions },
  getQuestionId (state) { return state.questionId },
  getQuestionsStat (state) { return state.questionsStat },
  getUrlQuestions (state) { return state.urlQuestions },
  getOrdersRating (state) { return state.ordersRating },
  getOrdersKontrollersDistinct (state) { return state.ordersKontrollersDistinct },
  getFindKontroller (state) { return state.findKontroller },
  getUrlRatingReport (state) { return state.urlRatingReport }
}
const mutations = {
  setTab (state, data) { state.tabs[role()][data.param].active = data.value },
  setProceeds (state, data) { state.proceeds = data },
  setProceedsReport (state, data) { state.proceedsReport = data },
  setMassage (state, data) { state.massage = data },
  setUrlProceeds (state, data) { state.urlProceeds = data },
  setUrlMassage (state, data) { state.urlMassage = data },
  setQuestions (state, data) { state.questions = data },
  setQuestionId (state, data) { state.questionId = data },
  setQuestionsStat (state, data) { state.questionsStat = data },
  setUrlQuestions (state, data) { state.urlQuestions = data },
  setOrdersRating (state, data) { state.ordersRating = data },
  setOrdersKontrollersDistinct (state, data) { state.ordersKontrollersDistinct = data },
  setFindKontroller (state, data) { state.findKontroller = data },
  setUrlRatingReport (state, data) { state.urlRatingReport = data }
}
const actions = {
  setActiveTab ({ commit, state }, data) {
    let param = data.param
    let tabs = state.tabs[role()]
    for (let tab in tabs) {
      if (param == tab) commit('setTab', { param: tab, value: true })
      else commit('setTab', { param: tab, value: false })
    };
  },
  async getOrdersProceeds ({ state, commit, dispatch }, data) {
    try {
      let result = await httpService.get(api.orders[role()].getProceeds, data.params)
      commit('setProceeds', { orderEnd: result.data.orderEnd, orderReturn: result.data.orderReturn, total: result.data.total, labels: result.data.labels })
    } catch (err) {
      console.log(err)
    };
  },
  async getOrdersProceedsReport ({ state, commit, dispatch }, data) {
    try {
      var offset = new Date().getTimezoneOffset()
      // console.log(offset);
      data.params.timezone = offset
      let result = await httpService.get(api.orders[role()].getProceedsReport, data.params)
      commit('setUrlProceeds', result.data)
    } catch (err) {
      console.log(err)
    };
  },
  async getOrdersMassage ({ state, commit, dispatch }, data) {
    try {
      let result = await httpService.get(api.orders[role()].getMassage, data.params)
      commit('setMassage', { massages: result.data.massages, total: result.data.total, labels: result.data.labels })
    } catch (err) {
      console.log(err)
    };
  },
  async getOrdersMassageReport ({ state, commit, dispatch }, data) {
    try {
      var offset = new Date().getTimezoneOffset()
      // console.log(offset);
      data.params.timezone = offset
      let result = await httpService.get(api.orders[role()].getMassageReport, data.params)
      commit('setUrlMassage', result.data)
    } catch (err) {
      console.log(err)
    };
  },
  async getQuestions ({ state, commit, dispatch }, data) {
    try {
      let result = await httpService.get(api.questions[role()].getAll, data.params)
      let questions = result.data.data
      commit('setQuestions', questions)
      if (questions.length) {
        commit('setQuestionId', questions[0].id)
        dispatch('getQuestionsStat', { params: { questionId: questions[0].id, limit: -1 } })
      }
    } catch (err) {
      console.log(err)
    };
  },
  async getQuestionsStat ({ state, commit, dispatch }, data) {
    try {
      let result = await httpService.get(api.questions[role()].getStat, data.params)
      commit('setQuestionsStat', result.data)
    } catch (err) {
      console.log(err)
    };
  },
  async getQuestionsReport ({ state, commit, dispatch }, data) {
    try {
      let result = await httpService.get(api.questions[role()].getReport, data.params)
      commit('setUrlQuestions', result.data)
    } catch (err) {
      console.log(err)
    };
  },
  async getOrdersRating ({ state, commit, dispatch }, data) {
    try {
      let result = await httpService.get(api.orders[role()].getRating, data.params)
      commit('setOrdersRating', result.data)
    } catch (err) {
      console.log(err)
    };
  },
  async getOrdersRatingReport ({ state, commit, dispatch }, data) {
    try {
      let result = await httpService.get(api.orders[role()].getRatingReport, data.params)
      commit('setUrlRatingReport', result.data)
    } catch (err) {
      console.log(err)
    };
  },
  async getKontrollersDistinct ({ state, commit, dispatch }, data) {
    try {
      let result = await httpService.get(api.orders[role()].getKontrollersDistinct, data.params)
      commit('setOrdersKontrollersDistinct', result.data)
    } catch (err) {
      console.log(err)
    };
  },
  async findKontroller ({ state, commit, dispatch }, data) {
    try {
      let result = await httpService.get(api.orders[role()].findKontroller, data.params)
      commit('setOrdersKontrollersDistinct', result.data)
    } catch (err) {
      console.log(err)
    };
  },

  async getGroupsStat ({ state, commit, dispatch }, data) {
    try {
      let result = await httpService.get(api.orders[role()].findKontroller, data.params)
      commit('setOrdersKontrollersDistinct', result.data)
    } catch (err) {
      console.log(err)
    };
  }

}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
